<template lang="">
  <div class="cash_box">
    <div class="banner_box">
      <img
        :src="baseUrl + '/kv@2x.png'"
        alt=""
        class="banner_img"
        id="banner_img"
        @load="LoadImg"
      />
      <img
        :src="imgUrl"
        :class="isFixed ? 'img_btn fixed' : 'img_btn'"
        @click="JsCallApp"
      />
    </div>
    <div class="box_ruler">
      <div class="ruler_list">
        <div class="title1">Time</div>
        <div class="title2">September 22-October 1, 2021</div>
      </div>
      <div class="ruler_list">
        <div class="title1">Reward arrival</div>
        <div class="txt">
          The newly added deposit balance will be issued a 1% cash reward every
          day
        </div>
      </div>
      <div class="ruler_list">
        <div class="title1">Reward amount</div>
        <div class="txt">
          total amount of cash back for a single user is up to 1,000 shillings,
          and the maximum is 100 shillings per day.
        </div>
      </div>
      <div class="ruler_list">
        <div class="title1">Reward users</div>
        <div class="txt">
          Registered users after September 1, 2021
        </div>
      </div>
      <div class="ruler_list">
        <div class="title1">Reward way</div>
        <div class="txt">
          Daily reward , Withdrawal at any time
        </div>
      </div>
      <div class="ruler_list ruler_list_last">
        <div class="title1">Newly added deposit</div>
        <div class="txt">
          New deposit amount after September 21，24:00:00 update daily
        </div>
      </div>
    </div>
    <div class="content">
      · Reward distribution from 1 Ksh, and a deposit of 100 Ksh or more is
      required to obtain the reward, amount reserved integer.For example, a
      newly added deposit of 199 shillings will be rewarded with 1 shilling and
      a newly added deposit of 200 shillings will be rewarded with 2 shillings.
      <br /><br />
      · Activity newly added deposit: current deposit balance-September 21st
      deposit balance = newly added deposit balance.For example, the balance of
      the deposit account on September 21 is 5000 shillings, the balance of the
      deposit account on September 22 is 15000 shillings, and the newly added
      deposit balance is 10000 shillings. On September 22, 1%*10000 shillings
      =100 shillings will be rewarded.<br /><br />
      · Reward description, a single user is rewarded up to 100 shillings per
      day, and the cumulative maximum reward is 1,000 shillings . For example,
      if a newly added deposit is 100-10,000 shillings, the daily reward is
      1-100 shillings, and the newly added deposit is 10,000 shillings or more,
      and the daily reward is 100 shillings.
    </div>
    <img src="@/assets/img/cashreward/logo@2x.png" alt="" class="logo" />
  </div>
</template>
<script>
import img1 from "@/assets/img/cashreward/btn1.png";
import img2 from "@/assets/img/cashreward/btn2.png";
export default {
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      ImgLoad: false,
      timer: null,
      imgUrl: img1,
    };
  },
  created() {
    this.timer = setInterval(() => {
      if (this.imgUrl == img1) {
        this.imgUrl = img2;
      } else {
        this.imgUrl = img1;
      }
    }, 500);
  },
  methods: {
    JsCallApp() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        var loadDateTime = new Date();
        window.setTimeout(function() {
          var timeOutDateTime = new Date();
          if (timeOutDateTime - loadDateTime < 5000) {
            window.location =
              "https://play.google.com/store/apps/details?id=kinvest.saving.bank.transfer.loan.kenya";
            window.onbeforeunload = function() {
              return false;
            };
          } else {
            window.close();
          }
        }, 25);
        window.location = "kinvest://";
      } else if (navigator.userAgent.match(/android/i)) {
        var loadDateTime2 = new Date();
        window.open("kinvest://", "_blank");
        window.setTimeout(function() {
          var timeOutDateTime2 = new Date();
          if (timeOutDateTime2 - loadDateTime2 < 5000) {
            window.location =
              "https://play.google.com/store/apps/details?id=kinvest.saving.bank.transfer.loan.kenya";
          } else {
            window.close();
          }
        }, 25);
      }
    },
    handleScroll() {
      // 得到页面滚动的距离
      if (this.ImgLoad) {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        this.isFixed = scrollTop > this.offsetTop;
      }
    },
    LoadImg() {
      let header = document.getElementById("banner_img");
      this.offsetTop = header.offsetHeight + 48;
      this.ImgLoad = true;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    // 离开该页面需要移除这个监听的事件，不然会报错
    window.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.cash_box {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  background: #2bacfe;
  padding-bottom: 180px;
  .banner_box {
    margin-bottom: 48px;
    position: relative;
    .banner_img {
      width: 100%;
      display: block;
      position: relative;
      z-index: 2;
    }
    .img_btn {
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: -48px;
      z-index: 10;
      cursor: pointer;
      &.fixed {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        max-width: 600px;
      }
    }
  }
  .box_ruler {
    width: calc(100% - 28px);
    padding: 20px 16px;
    box-sizing: border-box;
    background: #eaf5ff;
    box-shadow: 0px 2px 9px 0px rgba(43, 172, 254, 0.2);
    border-radius: 9px;
    margin: 0 auto;
    .ruler_list {
      margin-bottom: 16px;
      font-size: 14px;
      &.ruler_list_last {
        margin-bottom: 0;
      }
      .title1 {
        display: inline-block;
        vertical-align: top;
        padding: 0 8px;
        background: #ffae00;
        border-radius: 10px;
        height: 20px;
        line-height: 20px;
        font-family: "Po-Se";
        font-weight: 600;
        color: #ffffff;
        margin-right: 18px;
      }
      .title2 {
        display: inline-block;
        vertical-align: top;
        height: 20px;
        line-height: 20px;
        font-family: "Po-Regular";
        font-weight: 600;
        color: #017efe;
      }
      .txt {
        line-height: 20px;
        font-family: "Po-Regular";
        font-weight: 600;
        color: #017efe;
        margin-top: 6px;
      }
    }
  }
  .content {
    width: calc(100% - 28px);
    padding: 20px 16px;
    box-sizing: border-box;
    background: #009cff;
    box-shadow: 0px 2px 9px 0px rgba(43, 172, 254, 0.2);
    border-radius: 9px;
    margin: 10px auto;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
  }
  .logo {
    height: 22px;
    display: block;
    margin: 0 auto;
    cursor: pointer;
  }
}
</style>
